import { addMinutes, endOfDay, startOfDay } from "date-fns";
import { IPeriode } from "../utils/dateUtils";

export class storeCachePeriode implements IPeriode {
  fra: Date = new Date();
  tilOgMed: Date = new Date();
  Objects?: any[] | undefined;
  protected _expires?: Date;
  get expires(): Date {
    return this._expires || addMinutes(new Date(), 20);
  }
  set expires(value: Date) {
    this._expires = value;
  }
  constructor(periode: IPeriode) {
    this.fra = periode.fra;
    this.tilOgMed = periode.tilOgMed;
    this.Objects = periode.Objects;
  }
}

export interface IStoreCache {
  periodes: IPeriode[];
}

export class StoreCache implements IStoreCache {
  public periodes: storeCachePeriode[] = [];

  constructor(init?: Partial<IPeriode>) {
    Object.assign(this, init);
  }

  isCached(periode: IPeriode): boolean {
    const foundPeriods = this.periodes.filter((p) => {
      return (
        startOfDay(p.fra) <= startOfDay(periode.fra) &&
        endOfDay(p.tilOgMed) >= endOfDay(periode.tilOgMed) &&
        p.expires > new Date()
      );
    });
    // TODO: keys check on periode.objects
    if (periode.Objects) {
      // console.log("isCached", foundPeriods, this.periodes, { periode });
    }
    return foundPeriods.length > 0;
  }

  addCache(periode: storeCachePeriode): void {
    if (periode.fra == undefined || periode.tilOgMed == undefined) {
      throw new Error("fra og til og med datoen skal være udfyldt");
    }
    if (periode.fra > periode.tilOgMed) {
      throw new Error("fra må ikke være større end til og med datoen");
    }
    this.periodes = this.periodes.filter((p) => p.expires > new Date());
    // check if this.periodes contains periode, if so, update expires
    const foundPeriods = this.periodes.filter((p) => {
      return (
        startOfDay(p.fra) <= startOfDay(periode.fra) &&
        endOfDay(p.tilOgMed) >= endOfDay(periode.tilOgMed)
      );
    });
    if (foundPeriods.length > 0) {
      foundPeriods[0].expires = addMinutes(new Date(), 20);
      return;
    }

    periode.expires = addMinutes(new Date(), 20);
    this.periodes.push(new storeCachePeriode(periode));
  }

  resetCache(): void {
    this.periodes.length = 0;
  }
}
